<template>
	<Page>
		<div class="top">
			<TheAuthTop />
			<div class="balance-container">
				<div class="counter-hint">Balance</div>
				<div class="counter">{{ sumString }}</div>
			</div>

			<div class="actions">
				<RouterLink to="/transfer" class="action-button">
					<SendIcon class="action-button-icon" />
					<span>Send</span>
				</RouterLink>

				<RouterLink to="/swap" class="action-button">
					<SwapIcon class="action-button-icon" />
					<span>Swap</span>
				</RouterLink>

				<RouterLink to="/receive" class="action-button">
					<ReceiveIcon class="action-button-icon" />
					<span>Receive</span>
				</RouterLink>
			</div>
		</div>

		<div class="asset-list">
			<div v-if="!sortedBalanceAssetAmmounts" class="loading-animation"></div>

			<RouterLink
				v-for="assetAmount in sortedBalanceAssetAmmounts"
				:key="assetAmount.key"
				:to="`/asset/${assetIdToString(assetAmount.asset.assetId)}`"
			>
				<AssetAmountItem :assetAmount="assetAmount" />
			</RouterLink>
		</div>
	</Page>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBalanceStore } from '@/stores/useBalanceStore';
import AssetAmountItem from '@/components/AssetAmountItem.vue';
import { RouterLink } from 'vue-router';
import ButtonIcon from '../../components/ui/ButtonIcon.vue';
import TheAuthTop from './TheAuthTop.vue';
import ReceiveIcon from '@/assets/icons/arrow-down-left.svg?component';
import SendIcon from '@/assets/icons/arrow-up-right.svg?component';
import SwapIcon from '@/assets/icons/arrow-switch-horizontal.svg?component';
import { useWalletStore } from '@/stores/useWalletStore';
import { useTelegram } from '@/composables/useTelegram';
import Page from '@/components/ui/Page.vue';
import { assetIdToString } from '@/utils';

const { address } = useWalletStore();
const { telegram } = useTelegram();

const copyAddress = () => {
	navigator.clipboard.writeText(address!);
	telegram.WebApp.showAlert('Address copied to clipboard');
};

const sum = computed(() => {
	const balanceStore = useBalanceStore();

	return balanceStore.assetAmounts?.reduce((prev, cur) => {
		return prev + cur.amountToFloat() * (cur.asset.price || 0);
	}, 0);
});

const sumString = computed(() => {
	return `${(sum.value || 0).toFixed(2)}$`;
});

const sortedBalanceAssetAmmounts = computed(() => {
	const balanceStore = useBalanceStore();

	return balanceStore.assetAmounts?.sort((a, b) => b.inUsd() - a.inUsd());
});

// const { state } = useAsyncState(
// 	publicClient.value.getBalance({
// 		address: account.value.address
// 	}),
// 	0n
// );
</script>

<style scoped>
.top {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: var(--size-s);
}

.top .item {
	background-color: var(--secondary-background-color);
}

.avatar {
	border-radius: 50%;
	width: 40%;
}

.balance-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: var(--size-l) 0px var(--size-l) 0px;
}

.balance-container .counter {
	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 600;
	font-size: 32px;
	line-height: 130%;
	text-align: center;

	color: #ffffff;
}

.balance-delta {
	display: flex;
	flex-direction: row;
	font-size: var(--size-xl);
	font-weight: 300;
	color: rgb(114, 155, 114);
}

.balance-delta__sub {
	font-size: var(--size-xs);
}

.address {
	background-color: var(--secondary-background-color);
	/* border-radius: var(--size-s);
	padding: var(--size-micro) var(--size-xs); */
	cursor: pointer;

	display: flex;
	align-items: center;
}

.asset-list {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.header {
	display: flex;
}

.scroller {
	width: 100%;
	height: 100%;
}

.actions {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 8px 16px;

	background: rgba(255, 255, 255, 0.03);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 16px;
}

.action-button {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 4px;
	gap: 6px;

	flex: 1;
}

.action-button:not(:last-of-type) {
	border-right: 1px solid rgba(255, 255, 255, 0.05);
}

.counter-hint {
	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 11px;
	line-height: 13px;

	color: rgba(255, 255, 255, 0.7);
}

.action-button-icon {
	width: 24px;
	height: 24px;

	stroke: #027aff;

	stroke-opacity: 0.6;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}
</style>
